import { Component } from 'vue';

import JsonForm from '@evidentid/json-schema/interfaces/JsonForm';
import JsonSchema from '@evidentid/json-schema/interfaces/JsonSchema';
import { isArray, isEnum } from '@evidentid/json-schema/schemaChecks';
import { TprmSchema } from '@evidentid/tprm-portal-lib/models/common/TprmSchema.model';

export function getJsonSchemaCompFunction(
    customFormElementsMap: Record<string, Component>,
): (form: JsonForm, defaultComponents?: Record<string, Component>) => Component {
    return (form, defaultComponents: Record<string, Component> = {}) => {
        const compsMap = { ...defaultComponents, ...customFormElementsMap };
        const specialType = isArray(form.schema) && isEnum(form.schema.items as JsonSchema)
            ? 'multi_enum'
            : (form.schema as TprmSchema).displayFormat;
        return compsMap[specialType || ''] || compsMap[form.type];
    };
}
